export const SELLER_PAGE_IMAGE_FIT_MODES = ['cover', 'top', 'contain'];

// event.design → account.design → 'cover'; unknown/absent values degrade to 'cover'
// so old data and a lagging BE deploy render exactly as today.
export const resolveSellerPageImageFit = (eventDesign, accountDesign) => {
  const eventValue = eventDesign?.sellerPageImageFit;
  if (SELLER_PAGE_IMAGE_FIT_MODES.includes(eventValue)) return eventValue;
  const accountValue = accountDesign?.sellerPageImageFit;
  if (SELLER_PAGE_IMAGE_FIT_MODES.includes(accountValue)) return accountValue;
  return 'cover';
};

export const imageFitToStyle = (mode) => {
  if (mode === 'top') return { objectFit: 'cover', objectPosition: 'top' };
  if (mode === 'contain') return { objectFit: 'contain' };
  return { objectFit: 'cover' };
};

// Seller-page banner (#1403): a custom vertical focus point (0–100, % of the image kept in view)
// wins over the center/top preset. Absent/invalid values — old data, or a backend that does not
// return the field yet — fall back to the preset, so nothing changes until a seller sets one.
export const normalizeBannerFocusY = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  return Math.min(100, Math.max(0, Math.round(number)));
};

export const resolveBannerBackgroundPosition = (design) => {
  const focusY = normalizeBannerFocusY(design?.sellerPageBannerFocusY);
  if (focusY !== null) return `50% ${focusY}%`;
  return design?.sellerPageBannerPosition === 'top' ? 'top' : 'center';
};
